import React from "react";
import { SwitchContainer, SwitchKnobs } from "./Switch.style";

interface Props {
  checked: boolean;
  onClick: () => void;
}

const Switch: React.FC<Props> = props => {
  const onClick = () => {
    props.onClick();
  };
  return (
    <SwitchContainer checked={props.checked} onClick={onClick}>
      <SwitchKnobs checked={props.checked} />
    </SwitchContainer>
  );
};

export default Switch;
